import SashiDo from 'lib/SashiDo';
import * as DateUtils from 'lib/DateUtils';
import Icon from 'components/Icon/Icon.react';
import SashiDoTable from 'components/SashiDo/SashiDoTable.react';
import React, { Component } from 'react';
import PreLoader from 'components/PreLoader/PreLoader.react';
import styles from 'dashboard/Settings/Settings.scss';
import settingsStyles from 'dashboard/Settings/Settings.scss';
import stylesButton from 'components/Button/Button.scss';
import Toolbar from 'components/Toolbar/Toolbar.react';
import Tooltip from 'react-autotip';


import { activityTypes } from 'lib/Constants';


export default class AccountActivity extends Component {
  constructor(props) {
    super();

    this.section = 'Automatic Database Backups';
    this.subsection = 'List';

    const info = props.currentCustomer.info;

    this.state = {
      loading: true,
      currentPage: 1,
      note: null,
    };
  }

  componentDidMount() {
    SashiDo.activityFind({ page: 1, pageSize: 100 }).then((data) => {
      this.setState({
        data,
        loading: false,
      });
    });
  }

  browser(agent) {
    switch (true) {
      case agent.toLowerCase().indexOf('edge') > -1: return 'edge';
      case agent.toLowerCase().indexOf('opr') > -1 && !!window.opr: return 'Opera';
      case agent.toLowerCase().indexOf('chrome') > -1 && !!window.chrome: return 'Chrome';
      case agent.toLowerCase().indexOf('trident') > -1: return 'IE';
      case agent.toLowerCase().indexOf('firefox') > -1: return 'Firefox';
      case agent.toLowerCase().indexOf('safari') > -1: return 'Safari';
      default: return 'other';
    }
  }

  renderToolbar() {
    return null;
  }

  renderHeaders() {
    const headers = [
      <colgroup key={`${this.props.params.section}_colgroup`}>
        <col width="22%" />
        <col width="54%" />
        <col width="12%" />
        <col width="12%" />
      </colgroup>,
      <thead key={`${this.props.params.section}_thead`}>
        <tr>
          <th>Date</th>
          <th>Event</th>
          <th>IP</th>
          <th>Browser</th>
        </tr>
      </thead>,
    ];
    return headers;
  }

  renderRow(item) {
    const classes = [stylesButton.tableButton, stylesButton.blue];
    const { data } = item;

    let { message, params } = data;

    if (message === '' && params.message) {
      message = params.message;
    }

    return (
      <tr key={item.objectId}>
        <td>{DateUtils.yearMonthDayTimeFormatter(new Date(item.createdAt), true)}</td>
        <td>{message}</td>
        <td>{item.ip}</td>
        <td>
          <div className={styles.rowInfo}>
            {this.browser(item.browser)}
            <Tooltip
              text={<div dangerouslySetInnerHTML={{ __html: item.browser }} />}
              tooltipStyles={{
                  color: '#fff',
                  fontFamily: 'Ubuntu',
                  fontSize: 14,
                  fontWeigt: 300,
                  borderRadius: 4,
                  maxWidth: 300,
                  unit: 4,
                  lightgrey: '#222933',
                  opaqueGrey: '#222933',
              }}>
              <Icon name="icon-info" width={16} height={16} fill="#47689f" />
            </Tooltip>
          </div>
        </td>
      </tr>
    );
  }

  handleShowMore(page) {
    this.setState({ loading: true, currentPage: page });
    setTimeout(() => {
      SashiDo.activityFind({ page }).then((data) => {
        this.setState({
          data,
          loading: false,
        });
      });
    }, 400);
  }

  render() {
    const classes = [settingsStyles.settings_page, settingsStyles.default];

    if (!this.state.data) {
      return (
        <div className={classes.join(' ')}>
          <Toolbar section={this.props.section} subsection="Activity" />
          <div className={[settingsStyles.holder, 'ShowFooter'].join(' ')}>
            <div className={styles.holder}>
              <PreLoader loading={this.state.loading} />
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className={classes.join(' ')}>
        <Toolbar section={this.props.section} subsection="Activity" />
        <PreLoader loading={this.state.loading}>
          {
            // <div className={[styles.holder, styles.hasFooter].join(' ')}>
          }
          <div className={[styles.holder].join(' ')}>
            <div className="box table big">
              <SashiDoTable className="hover">
                {this.renderHeaders()}
                <tbody>
                  {this.state.data.map(row => this.renderRow(row))}
                </tbody>
              </SashiDoTable>
            </div>
            {
                // <div className={[styles.footer].join(' ')}>
                //   <Pagination
                //     total={this.state.data.length}
                //     current={this.state.currentPage}
                //     pageSize={50}
                //     showTitle={false}
                //     showQuickJumper={false}
                //     onChange={(current) => {
                //       this.handleShowMore(current)
                //     }} />
                // </div>
            }
          </div>
        </PreLoader>
      </div>
    );
  }
}
